type TaskStatusCreationError = {
  message: string;
};

const taskStatusCreationError: TaskStatusCreationError = {
  message: "",
};

export type { TaskStatusCreationError };

export { taskStatusCreationError };
